var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6546_19659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3407 9.71058C19.3407 8.93171 19.2789 8.36334 19.145 7.77393H10.4392V11.2894H15.5493C15.4463 12.163 14.89 13.4787 13.6536 14.3628L13.6363 14.4805L16.3889 16.659L16.5796 16.6784C18.331 15.0259 19.3407 12.5945 19.3407 9.71058Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4391 18.9729C12.9426 18.9729 15.0444 18.1308 16.5795 16.6783L13.6535 14.3627C12.8706 14.9205 11.8197 15.31 10.4391 15.31C7.98711 15.31 5.90599 13.6575 5.16413 11.3735L5.05539 11.383L2.19319 13.6459L2.15576 13.7522C3.68054 16.8467 6.81256 18.9729 10.4391 18.9729Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16414 11.3736C4.9684 10.7842 4.85511 10.1526 4.85511 9.50004C4.85511 8.84742 4.9684 8.21592 5.15385 7.62651L5.14866 7.50098L2.2506 5.20166L2.15578 5.24774C1.52735 6.53185 1.16675 7.97386 1.16675 9.50004C1.16675 11.0262 1.52735 12.4682 2.15578 13.7523L5.16414 11.3736Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4391 3.69016C12.1803 3.69016 13.3547 4.45851 14.0244 5.1006L16.6413 2.49029C15.0341 0.964108 12.9426 0.0273438 10.4391 0.0273438C6.81256 0.0273438 3.68054 2.15346 2.15576 5.2479L5.15383 7.62667C5.90599 5.34267 7.98711 3.69016 10.4391 3.69016Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6546_19659"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.16675,
    width: 18.1739,
    height: 19,
    rx: 9.08696,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Google.7bd3ac73fc98880f798127b9b8d4ab24.svg";